<script lang="ts">
  import { page_size, active_page } from "$components/episodes/gallery_store";
  import { onMount } from "svelte";
  import { browser } from "$app/environment";
  import { how_far_to_scroll_in_gallery, header_hiding } from "$lib/data";
  export let length: number = 0,
    bottom: boolean = false;

  let button_w: number;
  let holder_w: number;
  let pages: HTMLElement[] = [];
  let pages_holder: HTMLElement;
  let to_right_place = 0;

  $: number_of_pages = Math.ceil(length / $page_size);

  onMount(() => {
    to_right_place = pages_holder.getBoundingClientRect().top;

    window.scrollTo({
      top: $how_far_to_scroll_in_gallery,
      behavior: "smooth",
    });

    let touchstartX = 0;
    let touchendX = 0;

    function checkDirection() {
      if (Math.abs(touchendX - touchstartX) < 80) return;
      if (touchendX < touchstartX)
        if ($active_page !== number_of_pages) $active_page += 1; // prev
      if (touchendX > touchstartX) if ($active_page >= 2) $active_page -= 1; // next
    }

    document.addEventListener("touchstart", (e) => {
      touchstartX = e.changedTouches[0].screenX;
    });

    document.addEventListener("touchend", (e) => {
      touchendX = e.changedTouches[0].screenX;
      checkDirection();
    });
  });
  const button_touch = (element: HTMLElement) => {
    if (!browser) return;
    if (pages.length > 0 && element)
      pages_holder.scroll({
        left: element.offsetLeft - (holder_w / 2 - 48 / 2),
        behavior: "smooth",
      });

    window.scrollTo({
      top: $how_far_to_scroll_in_gallery,
      behavior: "smooth",
    });
  };

  $: $active_page, button_touch(pages[$active_page - 1]);
</script>

<nav class:bottom style:top="{$header_hiding ? 0 : 60}px">
  <div class="ends start">
    <button
      bind:clientWidth={button_w}
      on:click={() => ($active_page = 1)}
      disabled={$active_page === 1}
    >
      <svg
        fill="none"
        viewBox="0 0 24 24"
        height="24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M17.7071 5.29289C18.0976 5.68342 18.0976 6.31658 17.7071 6.70711L12.4142 12L17.7071 17.2929C18.0976 17.6834 18.0976 18.3166 17.7071 18.7071C17.3166 19.0976 16.6834 19.0976 16.2929 18.7071L10.2929 12.7071C9.90237 12.3166 9.90237 11.6834 10.2929 11.2929L16.2929 5.29289C16.6834 4.90237 17.3166 4.90237 17.7071 5.29289ZM11.7071 5.29289C12.0976 5.68342 12.0976 6.31658 11.7071 6.70711L6.41421 12L11.7071 17.2929C12.0976 17.6834 12.0976 18.3166 11.7071 18.7071C11.3166 19.0976 10.6834 19.0976 10.2929 18.7071L4.29289 12.7071C4.10536 12.5196 4 12.2652 4 12C4 11.7348 4.10536 11.4804 4.29289 11.2929L10.2929 5.29289C10.6834 4.90237 11.3166 4.90237 11.7071 5.29289Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
  <div class="ends start">
    <button
      on:click={() => {
        if ($active_page >= 2) $active_page -= 1;
      }}
      disabled={$active_page === 1}
    >
      <svg
        fill="none"
        viewBox="0 0 24 24"
        height="24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M14.7071 5.29289C15.0976 5.68342 15.0976 6.31658 14.7071 6.70711L9.41421 12L14.7071 17.2929C15.0976 17.6834 15.0976 18.3166 14.7071 18.7071C14.3166 19.0976 13.6834 19.0976 13.2929 18.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
  <div
    class="pages"
    bind:this={pages_holder}
    class:flex-fix={holder_w <= number_of_pages * button_w}
    bind:offsetWidth={holder_w}
  >
    <div>
      {#each { length: number_of_pages } as _, index}
        <button
          class:active={$active_page === index + 1}
          bind:this={pages[index]}
          on:click={() => ($active_page = index + 1)}
        >
          {index + 1}
        </button>
      {/each}
    </div>
  </div>
  <div class="ends end">
    <button
      on:click={() => {
        if ($active_page !== number_of_pages) $active_page += 1;
      }}
      disabled={$active_page === number_of_pages}
    >
      <svg
        fill="none"
        viewBox="0 0 24 24"
        height="24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L14.5858 12L9.29289 6.70711C8.90237 6.31658 8.90237 5.68342 9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
  <div class="ends end">
    <button
      on:click={() => ($active_page = number_of_pages)}
      disabled={$active_page === number_of_pages}
    >
      <svg
        fill="none"
        viewBox="0 0 24 24"
        height="24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M12.2929 5.29289C12.6834 4.90237 13.3166 4.90237 13.7071 5.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L13.7071 18.7071C13.3166 19.0976 12.6834 19.0976 12.2929 18.7071C11.9024 18.3166 11.9024 17.6834 12.2929 17.2929L17.5858 12L12.2929 6.70711C11.9024 6.31658 11.9024 5.68342 12.2929 5.29289ZM6.29289 5.29289C6.68342 4.90237 7.31658 4.90237 7.70711 5.29289L13.7071 11.2929C13.8946 11.4804 14 11.7348 14 12C14 12.2652 13.8946 12.5196 13.7071 12.7071L7.70711 18.7071C7.31658 19.0976 6.68342 19.0976 6.29289 18.7071C5.90237 18.3166 5.90237 17.6834 6.29289 17.2929L11.5858 12L6.29289 6.70711C5.90237 6.31658 5.90237 5.68342 6.29289 5.29289Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
</nav>

<style>
nav {
  position: sticky;
  font-size: 0.9rem;
  font-style: italic;
  display: flex;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--dots);
  margin: 0;
  z-index: 10;
  transition: top 100ms ease-out;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.06);
}
nav.bottom {
  border-top: 1px solid var(--dots);
  position: relative;
  top: 0;
  margin: 0 -3rem;
}
@media (max-width: 450px) {
  nav.bottom {
    margin: -1rem -1rem 1rem -1rem;
  }
}
nav button {
  border: none;
  background: white;
  height: 3rem;
  min-width: 3rem;
  display: inline-grid;
  place-content: center;
  background: white;
  color: var(--title);
  font-weight: bold;
  cursor: pointer;
}
nav button:hover {
  color: var(--primary);
}
nav button:disabled {
  color: var(--title);
  cursor: default;
}
nav button:disabled svg {
  opacity: 0.2;
}
nav .pages {
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  position: relative;
}
@media (max-width: 700px) {
  nav .pages {
    touch-action: pan-x;
    overflow: scroll;
  }
  nav .pages > div {
    transform: none !important;
  }
}
nav .pages.flex-fix {
  justify-content: flex-start;
}
nav .pages > div {
  display: flex;
  border-right: 1px solid var(--dots);
  transition: all 250ms ease-in-out;
}
nav .pages > div button {
  border-left: 1px solid var(--dots);
}
nav .pages > div button:hover {
  color: var(--secondary);
}
nav .active {
  background: var(--dots);
  border-bottom: 3px solid var(--primary);
}
nav .start button {
  border-right: 1px solid var(--dots);
}
nav .end button {
  border-left: 1px solid var(--dots);
}
</style>
